import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import CruiseLanguageService from "../../../../services/reservations/CruiseLanguageService";

export const REQUEST_CREATE_CRUISE_LANGUAGE = "REQUEST_CREATE_CRUISE_LANGUAGE";
export const CREATE_CRUISE_LANGUAGE_SUCCESS = "CREATE_CRUISE_LANGUAGE_SUCCESS";
export const CREATE_CRUISE_LANGUAGE_ERROR = "CREATE_CRUISE_LANGUAGE_ERROR";

function requestCreateCruiseLanguage() {
  return {
    type: REQUEST_CREATE_CRUISE_LANGUAGE,
  };
}

function createCruiseLanguageSuccess(json) {
  return {
    type: CREATE_CRUISE_LANGUAGE_SUCCESS,
    message: json.data,
  };
}

function createCruiseLanguageError(json) {
  return {
    type: CREATE_CRUISE_LANGUAGE_ERROR,
    error: json.data,
  };
}

export function createCruiseLanguage(cruise_id, payload) {
  return (dispatch) => {
    dispatch(requestCreateCruiseLanguage());
    return CruiseLanguageService.postCruiseLanguage(cruise_id, payload).then(
      (json) => {
        if (json.data.code === 200) {
          dispatch(createCruiseLanguageSuccess(json.data));
        } else if (json.data.code === 202) {
          updateLocalStorageToken(json.data.token);
          dispatch(createCruiseLanguage(cruise_id, payload));
        } else if (json.data.code === 498) {
          logOut();
        } else {
          dispatch(createCruiseLanguageError(json.data));
        }
      }
    );
  };
}
